import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "customer-reviews__header" }
const _hoisted_2 = { class: "customer-reviews__total-details" }

import { computed } from 'vue';
import CustomerReviewsDetailsGroup from '@lmt-rpb/CustomerReviewsDetailsGroup/CustomerReviewsDetailsGroup.vue';
import CustomerReviewsRatings from '@lmt-rpb/CustomerReviewsRatings/CustomerReviewsRatings.vue';
import { ratingText, isMinimumRating } from '@utils/utils';
import { RATING_MAX_VALUE } from '@global-js/constants';
import type { AggregateRatingType } from '@/interfaces/review-types';
import { storeToRefs } from 'pinia';
import { useBreakpointStore } from 'src/store/breakpointsStore';

interface Props {
	aggregatedRating: AggregateRatingType;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerReviewsHeader',
  props: {
    aggregatedRating: {}
  },
  setup(__props: any) {

const props = __props;

const { isMinTablet } = storeToRefs(useBreakpointStore());

const totalRatingText = computed(() => {
	const rating = {
		ratingLabel: `${ratingText(props.aggregatedRating.RatingOverallValue)} – `,
		recommendationRate: `${props.aggregatedRating.RatingRecommendationRate}`,
	};
	if (!isMinimumRating(props.aggregatedRating.RatingOverallValue)) {
		rating.ratingLabel = '';
	}
	return rating;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CustomerReviewsRatings, {
      "rating-label": totalRatingText.value.ratingLabel,
      "recommendation-rate": props.aggregatedRating.RatingRecommendationRate,
      "rating-count": _ctx.aggregatedRating.RatingCount,
      "rating-overall-value": props.aggregatedRating.RatingOverallValue
    }, null, 8 /* PROPS */, ["rating-label", "recommendation-rate", "rating-count", "rating-overall-value"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CustomerReviewsDetailsGroup, {
        details: _ctx.aggregatedRating.Ratings,
        "is-always-open": _unref(isMinTablet),
        "max-value": _unref(RATING_MAX_VALUE)
      }, null, 8 /* PROPS */, ["details", "is-always-open", "max-value"])
    ])
  ]))
}
}

})